import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import mapImage from '../assets/ian-map.png';
import hubImage from '../assets/ev91-hub-image.png';
import '../assets/Css_Folder/Services.css'
import ScrollToTopButton from '../components/ScrollToTopButton';
import footerimg from '../assets/clients-picture.jpg';
// import bgIMG from '../assets/google-maps.jpg';
import clientLogo1 from '../assets/client-logo1.png';
import clientLogo2 from '../assets/client-logo2.png';
import clientLogo3 from '../assets/client-logo3.png';
import clientLogo4 from '../assets/client-logo4.png';
import clientLogo6 from '../assets/client-logo6.png';
import clientLogo8 from '../assets/client-logo8.png';
import clientLogo9 from '../assets/client-logo9.png';
import clientLogo10 from '../assets/client_logo-10.png';
import clientLogo11 from '../assets/client_logo-11.png';
import clientLogo12 from '../assets/client_logo-12.webp';
import flipkart_min from '../assets/flipkart_min.webp';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, BarChart, Bar } from 'recharts';

const Client_data =[
    {
        client: clientLogo1,
        CO2: "🌍",
        trees: "🌱",
        CO2_data: "102205.7",
        tree_data: "4866.9"
    },
     {
        client: clientLogo2,
        CO2: "🌍",
        trees: "🌱",
        CO2_data: "284373.9",
        tree_data: "13541.6"
    },
     {
        client: clientLogo3,
        CO2: "🌍",
        trees: "🌱",
        CO2_data: "39.2",
        tree_data: "1.86"
    },
    {
        client: clientLogo4,
        CO2: "🌍",
        trees: "🌱",
        CO2_data: "1716.8",
        tree_data: "81.7"
    },{
        client: clientLogo6,
        CO2: "🌍",
        trees: "🌱",
        CO2_data: "79851.9",
        tree_data: "3802.4"
    },
     {
        client: clientLogo8,
        CO2: "🌍",
        trees: "🌱",
        CO2_data: "10878.3",
        tree_data: "518.01"
    },
     {
        client: clientLogo9,
        CO2: "🌍",
        trees: "🌱",
        CO2_data: "1595.8",
        tree_data: "75.9"
    },
    {
        client: clientLogo10,
        CO2: "🌍",
        trees: "🌱",
        CO2_data: "679.9",
        tree_data: "32.3"
    },
    {
        client: clientLogo11,
        CO2: "🌍",
        trees: "🌱",
        CO2_data: "4048.8",
        tree_data: "192.8"
    },
    {
        client: clientLogo12,
        CO2: "🌍",
        trees: "🌱",
        CO2_data: "520.8",
        tree_data: "24.8"
    },
    {
        client: flipkart_min,
        CO2: "🌍",
        trees: "🌱",
        CO2_data: "3878.5",
        tree_data: "184.6"
    }
    
]


const services = [
  {
    title: 'EV-Based Delivery',
    description: 'Experience swift, reliable delivery with our top-notch service. Your goods, delivered with precision and care wherever you need them.',
  },
  {
    title: '3PL (Third-Party Logistics)',
    description: 'Streamline your supply chain with our reliable third-party logistics solutions. Efficient and scalable logistics tailored for your business.',
  },
  {
    title: 'EV-Rental',
    description: 'Drive the future with our premium EV rentals—eco-friendly and efficient. Rent an electric vehicle today and experience sustainable mobility.',
  },
];

const statsData = [
  { name: "CO₂ Saved", value: 490 },
  { name: "Trees Impact", value: 23 },
  { name: "EV Miles", value: 2000 },
  { name: "Battery Swaps", value: 50 },
];

const trendData = [
  { month: 'Jan', CO2: 50, EV: 400, Trees: 3 },
  { month: 'Feb', CO2: 70, EV: 500, Trees: 4 },
  { month: 'Mar', CO2: 90, EV: 600, Trees: 5 },
  { month: 'Apr', CO2: 120, EV: 650, Trees: 6 },
  { month: 'May', CO2: 150, EV: 700, Trees: 7 },
];

const Services = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeService, setActiveService] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', description: '' });
  const [errors, setErrors] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);

  const handleOpenModal = (serviceTitle) => {
    setActiveService(serviceTitle);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenForm = () => {
    setShowModal(false);
    setFormData({ name: '', email: '', phone: '', description: '' });
    setErrors({});
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required';
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.phone) {
      newErrors.phone = 'Phone number is required';
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = 'Phone number is invalid';
    }
    if (!formData.description) newErrors.description = 'Description is required';
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      console.log('Form submitted:', formData);
      setShowForm(false);
      setShowModal(false);
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
    } else {
      setErrors(validationErrors);
    }
  };

  const getModalContent = (serviceTitle) => {
    switch (serviceTitle) {
      case 'EV-Based Delivery':
        return (
          <>
            <h3 className="text-2xl font-bold mb-4 text-green-800 text-center">EV-Based Delivery</h3>
            <p className="text-gray-700 mb-4">
              Our EV-Based Pickup and Drop service offers a sustainable solution for transporting your products with utmost care and efficiency. Designed to meet the needs of both businesses and individuals, our service ensures timely and secure delivery of your goods.
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4">
              <li>Eco-friendly electric vehicles for zero-emission transportation.</li>
              <li>Flexible pickup and drop-off scheduling to suit your needs.</li>
              <li>Real-time tracking and notifications for seamless communication.</li>
              <li>Professional drivers trained to handle your products with care.</li>
              <li>Enhanced safety measures to protect your goods during transit.</li>
            </ul>
            <p className="text-gray-700">
              Our service is ideal for a wide range of applications, from delivering packages and merchandise to transporting sensitive items. Experience the future of logistics with our innovative EV-based solution that combines sustainability with superior service.
            </p>
          </>
        );
      case '3PL (Third-Party Logistics)':
        return (
          <>
            <h3 className="text-2xl font-bold mb-4 text-green-800 text-center">3PL (Third-Party Logistics)</h3>
            <p className="text-gray-700 mb-4">
              Comprehensive Supply Chain Management: We manage every aspect of your supply chain, from warehousing and inventory management to transportation and delivery. Our end-to-end service ensures that all components of your supply chain work together seamlessly.
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4">
              <li>Scalable Solutions: Whether you're a small business or a large enterprise, our 3PL services are designed to scale with your operations.</li>
              <li>Advanced Technology: Our logistics solutions are powered by the latest technology.</li>
              <li>Cost Efficiency: By outsourcing your logistics operations to us, you benefit from our expertise and infrastructure.</li>
              <li>Dedicated Support: Our team of logistics professionals provides dedicated support and personalized service.</li>
              <li>Global Reach: Our logistics network spans multiple regions, enabling us to manage international shipments.</li>
            </ul>
          </>
        );
      case 'EV-Rental':
        return (
          <>
            <h3 className="text-2xl font-bold mb-4 text-green-800 text-center">EV-Rental</h3>
            <p className="text-gray-700 mb-4">
              Diverse Fleet: Choose from a variety of electric scooters and motorcycles. Our fleet includes models that cater to different needs.
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4">
              <li>Eco-Friendly Transportation: Our electric 2-wheelers produce zero emissions.</li>
              <li>Innovative Technology: Experience the latest in electric mobility technology.</li>
              <li>Convenient Charging Solutions: We provide access to a network of charging stations.</li>
              <li>Comfort and Safety: Enjoy a comfortable ride with features such as ergonomic seating.</li>
              <li>Flexible Rental Options: We offer flexible rental terms to suit your needs.</li>
              <li>Affordable Pricing: Benefit from competitive rental rates with no hidden fees.</li>
            </ul>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Our Services | EV91Technologies</title>
        <meta name="description" content="Explore the range of services offered by EV91Technologies (VOICE): EV-based delivery, 3PL logistics, EV rentals, and more." />
        <meta name="keywords" content="Services, EV91, VOICE, delivery, logistics, EV rental, electric vehicles" />
        <meta property="og:title" content="Our Services | EV91Technologies" />
        <meta property="og:description" content="Explore the range of services offered by EV91Technologies (VOICE): EV-based delivery, 3PL logistics, EV rentals, and more." />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ev91riderz.com/services" />
        <link rel="canonical" href="https://ev91riderz.com/services" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Our Services | EV91Technologies",
            "description": "Explore the range of services offered by EV91Technologies (VOICE): EV-based delivery, 3PL logistics, EV rentals, and more.",
            "url": "https://ev91riderz.com/services"
          }
        `}</script>
      </Helmet>
      <div>
        <section className="relative -mt-6 overflow-hidden bg-slate-950 px-5 py-20 text-white lg:px-8">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(190,242,100,0.18),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(16,185,129,0.2),transparent_40%)]"></div>
          <div className="relative mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1fr_0.95fr] lg:items-center">
            <div>
              <p className="text-sm font-black uppercase tracking-[0.26em] text-lime-300">EV91 Services</p>
              <h1 className="mt-4 text-4xl font-black tracking-tight md:text-6xl">
                Electric delivery, EV rental, and 3PL operations built for city scale.
              </h1>
              <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300">
                From riders and vehicles to hub operations and enterprise delivery, VOICE keeps last-mile logistics cleaner and more dependable.
              </p>
              <div className="mt-8 flex flex-wrap gap-3">
                <a href="#our-section" className="rounded-full bg-lime-300 px-7 py-3 font-black text-slate-950 transition hover:-translate-y-0.5 hover:bg-white">
                  Explore services
                </a>
              </div>
            </div>
            <div className="rounded-[2rem] border border-white/10 bg-white/8 p-4 shadow-2xl shadow-black/25 backdrop-blur">
              <img src={hubImage} alt="EV91 service network" className="h-[360px] w-full rounded-[1.5rem] object-contain" />
              <div className="mt-4 grid grid-cols-3 gap-3 text-center">
                {["EV delivery", "3PL logistics", "EV rental"].map((item) => (
                  <div key={item} className="rounded-2xl px-3 py-4 text-sm font-black text-lime-100">
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

         <section className="hidden">
        {/* Glowing Gradient Blobs */}
        <div className="absolute -top-32 -left-32 w-96 h-96 bg-green-400 opacity-30 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-[-60px] right-[-40px] w-96 h-96 bg-green-600 opacity-20 rounded-full blur-2xl animate-ping" />

        {/* Hero Content */}
        <div className="relative z-10 max-w-6xl mx-auto text-center backdrop-blur-md bg-white/10 p-2 rounded-3xl border border-white/10 shadow-2xl">
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-lime-300 mb-4">
            🚀 EV Mobility, Logistics & Rental Services
          </h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto">
           VOICE drives efficiency, affordability, and zero emissions. ♻️🛵🔋
          </p>
          <a
            href="#our-section"
            className="mt-8 inline-block bg-white text-green-800 font-bold px-6 py-3 rounded-full shadow hover:bg-green-100 transform hover:scale-105 transition-all duration-200"
          >
            Learn More ⚡
          </a>
        </div>
      </section>

      <section className="relative py-24 bg-gradient-to-b from-green-50 via-white to-green-100 overflow-hidden">
  {/* Floating Energy Particles */}
  <div className="absolute top-10 left-1/4 w-2 h-2 bg-green-400 rounded-full animate-ping-slow opacity-50"></div>
  <div className="absolute top-1/2 right-1/3 w-3 h-3 bg-emerald-400 rounded-full animate-ping-slow opacity-40"></div>
  <div className="absolute bottom-20 left-1/3 w-2 h-2 bg-green-300 rounded-full animate-ping-slow opacity-50"></div>

  <div className="container mx-auto px-6 relative z-10">
    {/* Section Heading */}
    <h2 className="text-4xl md:text-5xl font-extrabold text-center text-green-900 mb-16 drop-shadow-lg animate-fade-in-up">
      ⚡ VOICE Services in Motion
      <span className="block w-28 h-1 mx-auto mt-3 bg-gradient-to-r from-green-400 via-emerald-500 to-green-700 rounded-full animate-gradient-x"></span>
    </h2>

    {/* EV Motion Path */}
    <div className="relative flex flex-col lg:flex-row items-center justify-between gap-12">
      {/* Milestones */}
      {[
        { icon: "🛵", title: "EV Logistics", desc: "Seamless green delivery solutions for urban mobility." },
        { icon: "🔋", title: "Fleet Management", desc: "Optimized EV fleet operations with smart tracking." },
        { icon: "📦", title: "On-Demand Delivery", desc: "Fast, eco-friendly delivery for businesses and customers." },
        { icon: "🤝", title: "Partnerships", desc: "Collaborate with enterprises & gig workers for greener impact." },
        { icon: "⚡", title: "VOICE Core", desc: "Tech-powered EV solutions driving sustainability & efficiency." },
      ].map((service, idx) => (
        <div
          key={idx}
          className={`relative flex flex-col items-center text-center z-10 ${
            idx % 2 === 0 ? "lg:translate-y-0" : "lg:-translate-y-10"
          } group`}
        >
          <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center text-3xl text-green-700 shadow-lg border-4 border-green-300 transition-transform duration-500 group-hover:scale-110">
            {service.icon}
          </div>
          <h3 className="mt-4 text-xl font-bold text-green-900">{service.title}</h3>
          <p className="mt-2 text-gray-700 text-sm md:text-base max-w-xs">{service.desc}</p>

          {/* Pulsing glow under icon */}
          <div className="absolute bottom-[-8px] w-6 h-6 bg-green-400 rounded-full opacity-30 blur-xl animate-pulse"></div>
        </div>
      ))}
    </div>
  </div>

  {/* Animations */}
  <style>{`
    @keyframes fade-in-up {
      0% { opacity: 0; transform: translateY(20px); }
      100% { opacity: 1; transform: translateY(0); }
    }
    .animate-fade-in-up { animation: fade-in-up 0.8s ease-out forwards; }

    @keyframes gradient-x {
      0% { background-position: 0% }
      50% { background-position: 100% }
      100% { background-position: 0% }
    }
    .animate-gradient-x {
      background-size: 200% 100%;
      animation: gradient-x 4s linear infinite;
    }

    @keyframes ping-slow {
      0% { transform: scale(0.5); opacity: 0.4; }
      50% { transform: scale(1); opacity: 0.7; }
      100% { transform: scale(0.5); opacity: 0.4; }
    }
    .animate-ping-slow { animation: ping-slow 3s infinite; }
  `}</style>
</section>


<section className="hidden" id="ev91-services-orbit">
  {/* Header */}
  <div className="text-center pt-8 pb-24">
    <h2 className="text-4xl lg:text-5xl font-bold text-green-800 drop-shadow-sm">
     🚀 Discover EV91 Services in Motion
    </h2>
    <p className="text-gray-700 mt-2 font-medium">
      Powering Logistics, Rentals & Delivery through EV Innovation
    </p>
  </div>

  {/* Center Emoji */}
  <div className="absolute top-[58%] left-1/2 z-10 transform -translate-x-1/2 -translate-y-1/2 text-center">
    <span className="text-7xl sm:text-8xl md:text-9xl">🛵</span>
    <p className="text-green-800 font-bold mt-3 text-lg">EV Hub</p>
  </div>

  {/* Orbiting Emojis */}
  <div className="absolute top-[58%] left-1/2 w-[300px] h-[300px] sm:w-[420px] sm:h-[420px] md:w-[500px] md:h-[500px] transform -translate-x-1/2 -translate-y-1/2">
    <div className="w-full h-full relative animate-orbit">
      <div className="emoji-item absolute top-0 left-1/2 transform -translate-x-1/2 text-center">
        <span className="text-4xl sm:text-5xl md:text-6xl">⚡</span>
        <p className="text-sm mt-1 text-gray-700 font-semibold">Fast Charging</p>
      </div>
      <div className="emoji-item absolute top-[12%] right-[6%] text-center">
        <span className="text-4xl sm:text-5xl md:text-6xl">🧾</span>
        <p className="text-sm mt-1 text-gray-700 font-semibold">Fleet Delivery</p>
      </div>
      <div className="emoji-item absolute top-1/2 right-0 transform -translate-y-1/2 text-center">
        <span className="text-4xl sm:text-5xl md:text-6xl">🔋</span>
        <p className="text-sm mt-1 text-gray-700 font-semibold">Battery Swap</p>
      </div>
      <div className="emoji-item absolute bottom-[12%] right-[6%] text-center">
        <span className="text-4xl sm:text-5xl md:text-6xl">🌱</span>
        <p className="text-sm mt-1 text-gray-700 font-semibold">sustainability</p>
      </div>
      <div className="emoji-item absolute bottom-0 left-1/2 transform -translate-x-1/2 text-center">
        <span className="text-4xl sm:text-5xl md:text-6xl">🧰</span>
        <p className="text-sm mt-1 text-gray-700 font-semibold">Maintenance</p>
      </div>
      <div className="emoji-item absolute bottom-[12%] left-[6%] text-center">
        <span className="text-4xl sm:text-5xl md:text-6xl">📦</span>
        <p className="text-sm mt-1 text-gray-700 font-semibold">3PL Services</p>
      </div>
      <div className="emoji-item absolute top-1/2 left-0 transform -translate-y-1/2 text-center">
        <span className="text-4xl sm:text-5xl md:text-6xl">🛠️</span>
        <p className="text-sm mt-1 text-gray-700 font-semibold">Repair</p>
      </div>
      <div className="emoji-item absolute top-[12%] left-[6%] text-center">
        <span className="text-4xl sm:text-5xl md:text-6xl">🧑‍🔧</span>
        <p className="text-sm mt-1 text-gray-700 font-semibold">Maintenance</p>
      </div>
    </div>
  </div>

  {/* Orbit Animation */}
  <style>
    {`
      @keyframes orbit {
        0%   { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .animate-orbit {
        animation: orbit 25s linear infinite;
        transform-origin: center;
      }
      .emoji-item {
        transform-origin: center;
        width: 90px;
      }
    `}
  </style>
</section>

      
     <section className="py-20 bg-gradient-to-br from-white via-green-50 to-white" id="our-section">
  <div className="container mx-auto px-4">
    <h2 className="text-5xl font-extrabold mb-14 text-center text-green-800 drop-shadow-lg">
      🛠️ EV91 Core Services
    </h2>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
      {services.map((service, index) => (
        <div
          key={index}
          className="relative group backdrop-blur-sm bg-white/70 border border-green-200 p-8 rounded-3xl shadow-lg hover:shadow-2xl hover:scale-[1.03] transition-transform duration-300"
          style={{ minHeight: '360px' }}
        >
          {/* Decorative blurred shapes */}
          <div className="absolute -top-12 -left-12 w-32 h-32 bg-green-200 opacity-30 rounded-full blur-2xl group-hover:scale-125 transition-transform duration-500"></div>
          <div className="absolute -bottom-12 -right-12 w-36 h-36 bg-green-400 opacity-20 rounded-full blur-2xl group-hover:scale-125 transition-transform duration-500"></div>

          {/* Icon animation */}
          <div className="mb-5 flex items-center justify-center w-16 h-16 rounded-full bg-green-100 border-2 border-green-300 shadow-md animate-pulse text-3xl text-green-700">
            {index === 0 && <span role="img" aria-label="EV">⚡</span>}
            {index === 1 && <span role="img" aria-label="3PL">🛵</span>}
            {index === 2 && <span role="img" aria-label="Rental">🔋</span>}
          </div>

          <h3 className="text-2xl font-bold mb-3 text-green-900 tracking-tight">{service.title}</h3>
          <p className="text-gray-700 font-medium leading-relaxed mb-6">{service.description}</p>

          {/* Stylish animated button */}
          <>
            <style>
              {`
                @keyframes greenGlow {
                  0% {
                    box-shadow: 0 0 6px 2px rgba(34, 197, 94, 0.7);
                  }
                  50% {
                    box-shadow: 0 0 12px 5px rgba(22, 163, 74, 0.85);
                  }
                  100% {
                    box-shadow: 0 0 6px 2px rgba(34, 197, 94, 0.7);
                  }
                }
                .glow-button {
                  animation: greenGlow 2.2s infinite;
                  transition: transform 0.3s ease, background 0.3s ease;
                }
                .glow-button:hover {
                  transform: scale(1.05);
                }
              `}
            </style>

            <button
              onClick={() => handleOpenModal(service.title)}
              className="glow-button mt-auto px-6 py-2 bg-gradient-to-r from-green-600 to-green-400 text-white rounded-full font-semibold shadow-md hover:from-green-700 hover:to-green-500 focus:outline-none"
              aria-label={`Learn more about ${service.title}`}
            >
              Learn More
            </button>
          </>
        </div>
      ))}
    </div>
  </div>
</section>

      <section className="relative py-24 bg-slate-950 text-white">
  <div className="container mx-auto px-4">
    <h2 className="text-5xl font-extrabold mb-16 text-center text-white drop-shadow-lg">
      ♻️ Where Sustainability Meets Service
    </h2>

    <div className="relative w-full max-w-6xl mx-auto h-[700px] md:h-[750px]">
      
      {/* Top-Left Wheel */}
      <div className="absolute top-0 left-0 w-44 h-44 md:w-56 md:h-56 bg-green-300 rounded-full shadow-2xl flex items-center justify-center p-6 text-center">
        <div>
          <h3 className="text-xl font-bold text-green-900 mb-2">🔌 EV Rental Power</h3>
          <p className="text-sm text-gray-700">Give delivery heroes access to clean, reliable electric vehicles.</p>
        </div>
      </div>

      {/* Top-Right Wheel */}
      <div className="absolute top-0 right-0 w-44 h-44 md:w-56 md:h-56 bg-green-300 rounded-full shadow-2xl flex items-center justify-center p-6 text-center">
        <div>
          <h3 className="text-xl font-bold text-green-900 mb-2">📦 Smart 3PL Logistics</h3>
          <p className="text-sm text-gray-700">Move goods with precision and green-conscious delivery.</p>
        </div>
      </div>

      {/* Middle Rectangle Boxes */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3/4 md:w-2/3 flex flex-col md:flex-row gap-6">
        <div className="bg-white/90 backdrop-blur-lg border border-green-200 p-6 rounded-3xl shadow-md flex-1 text-center hover:shadow-green-300 transition-transform transform hover:-translate-y-1">
          <h3 className="text-xl font-bold text-green-900 mb-2">⚡ Electric Last-Mile</h3>
          <p className="text-gray-700 text-sm">Deliveries done right — zero emissions, real-time tracking, trusted EV91 riders.</p>
        </div>
        <div className="bg-white/90 backdrop-blur-lg border border-green-200 p-6 rounded-3xl shadow-md flex-1 text-center hover:shadow-green-300 transition-transform transform hover:-translate-y-1">
          <h3 className="text-xl font-bold text-green-900 mb-2">🛠️ Maintenance-Free EVs</h3>
          <p className="text-gray-700 text-sm">We handle servicing, ensuring smooth rides and safety for all rentals.</p>
        </div>
      </div>

      {/* Bottom-Left Wheel */}
      <div className="absolute bottom-0 left-0 w-44 h-44 md:w-56 md:h-56 bg-green-300 rounded-full shadow-2xl flex items-center justify-center p-6 text-center ">
        <div>
          <h3 className="text-xl font-bold text-green-900 mb-2">📍 Hub-to-Door Delivery</h3>
          <p className="text-sm text-gray-700">Seamless coverage from EV91 Hubs to any pin code.</p>
        </div>
      </div>

      {/* Bottom-Right Wheel */}
      <div className="absolute bottom-0 right-0 w-44 h-44 md:w-56 md:h-56 bg-green-300 rounded-full shadow-2xl flex items-center justify-center p-6 text-center">
        <div>
          <h3 className="text-xl font-bold text-green-900 mb-2">🌐 Nationwide EV Network</h3>
          <p className="text-sm text-gray-700">Growing green city by city — India’s electric logistics revolution.</p>
        </div>
      </div>

    </div>
  </div>
</section>




<section className="py-24 relative overflow-hidden">
  {/* Background Orbs */}
  <div className="absolute top-0 left-0 w-full h-full bg-[linear-gradient(45deg,transparent_25%,rgba(34,197,94,0.05)_25%,rgba(34,197,94,0.05)_50%,transparent_50%,transparent_75%,rgba(34,197,94,0.05)_75%)] bg-[length:100px_100px] animate-gradient-slide"></div>
  <div className="absolute top-10 left-10 w-96 h-96 bg-green-400/10 rounded-full blur-3xl animate-float"></div>
  <div className="absolute bottom-20 right-10 w-96 h-96 bg-emerald-400/10 rounded-full blur-3xl animate-float-delayed"></div>

  <div className="container mx-auto px-4 relative z-10">
    <h2 className="text-5xl font-extrabold text-center bg-clip-text text-transparent bg-gradient-to-r from-green-800 via-green-600 to-green-900 mb-16">
      EV91 Impact Dashboard
      <div className="w-32 h-2 mx-auto mt-4 rounded-full bg-gradient-to-r from-green-400 via-emerald-500 to-green-600"></div>
    </h2>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
      {/* Left: Stats + Graph Cards */}
      <div className="grid grid-cols-2 gap-6">
        {statsData.map((stat, idx) => (
          <div key={idx} className="bg-white/80 backdrop-blur-xl rounded-2xl p-6 border border-green-100 shadow-xl hover:shadow-green-200 transition-all duration-500 flex flex-col items-center">
            <h3 className="text-4xl mb-2">{stat.name === "CO₂ Saved" ? "🌍" : stat.name === "Trees Impact" ? "🌳" : stat.name === "EV Miles" ? "⚡" : "🔋"}</h3>
            <h4 className="text-3xl font-bold text-green-800 mb-2">{stat.value}{stat.name === "CO₂ Saved" ? "K+" : stat.name === "EV Miles" ? "K km+" : stat.name === "Trees Impact" ? "K trees" : "K swaps"}</h4>
            <div className="w-full h-24">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={[{ name: stat.name, value: stat.value }]}>
                  <Bar 
                    dataKey="value" 
                    fill="#22c55e" 
                    radius={[6,6,0,0]} 
                  />
                  {/* Remove the Tooltip component to eliminate the hover effect */}
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        ))}
      </div>

      {/* Right: Trend Charts */}
      <div className="space-y-6">
        <div className="bg-white/80 backdrop-blur-xl rounded-2xl p-6 border border-green-100 shadow-xl hover:shadow-green-200 transition-all duration-500">
          <h3 className="text-2xl font-bold text-green-800 mb-4">Monthly EV & CO₂ Trend</h3>
          <ResponsiveContainer width="100%" height={200}>
            <LineChart data={trendData}>
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="CO2" stroke="#16a34a" strokeWidth={3} />
              <Line type="monotone" dataKey="EV" stroke="#22c55e" strokeWidth={3} />
              <Line type="monotone" dataKey="Trees" stroke="#4ade80" strokeWidth={3} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="bg-white/80 backdrop-blur-xl rounded-2xl p-6 border border-green-100 shadow-xl hover:shadow-green-200 transition-all duration-500">
          <h3 className="text-2xl font-bold text-green-800 mb-4">Detailed Impact Categories</h3>
          <div className="grid grid-cols-1 gap-4">
            <div className="flex items-center gap-4">
              <span className="text-3xl">🌿</span>
              <div>
                <h4 className="text-lg font-semibold text-green-800">Emission Reduction</h4>
                <p className="text-gray-600">Active reduction in urban pollution levels</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <span className="text-3xl">🌳</span>
              <div>
                <h4 className="text-lg font-semibold text-green-800">Forest Conservation</h4>
                <p className="text-gray-600">Supporting reforestation through verified programs</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <span className="text-3xl">♻️</span>
              <div>
                <h4 className="text-lg font-semibold text-green-800">Sustainable Operations</h4>
                <p className="text-gray-600">End-to-end green logistics solutions</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Add these animations */}
  <style jsx>{`
     @keyframes gradient-slide {
      0% { background-position: 0% 0%; }
      100% { background-position: 100% 100%; }
    }
    .animate-gradient-slide {
      animation: gradient-slide 15s linear infinite;
    }
    @keyframes pulse-slow {
      0%, 100% { opacity: 0.3; }
      50% { opacity: 0.5; }
    }
    .animate-pulse-slow {
      animation: pulse-slow 2s ease-in-out infinite;
    }
    .animate-pulse {
      animation: pulse-slow 2s ease-in-out infinite;
    }
  `}</style>
</section>


      {/* Client Impact Cards Section with Auto-Scroll Animation (smaller cards) */}
      <section className="py-20 bg-slate-950 text-white">
        <div className="container mx-auto px-4">
          <div className="mx-auto mb-10 max-w-3xl text-center">
            <p className="text-sm font-black uppercase tracking-[0.24em] text-lime-300">Partner Footprint</p>
            <h2 className="mt-3 text-4xl font-black text-white md:text-5xl">Client Impact</h2>
            <p className="mt-4 text-slate-300">A moving snapshot of cleaner delivery work across our partner network.</p>
          </div>
         <h2 className="hidden">Client Impact</h2>

          <div className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-white/8 p-4 shadow-2xl shadow-black/20">
            <div
              className="flex gap-5 animate-scroll-x"
              style={{
                width: 'max-content',
                animation: 'scroll-x 30s linear infinite',
              }}
            >
              {[...Client_data, ...Client_data].map((client, idx) => (
                <div
                  key={idx}
                  className="group min-w-[210px] max-w-[220px] overflow-hidden rounded-[1.5rem] border border-white/10 bg-white p-4 text-slate-950 shadow-xl shadow-black/10 transition-transform duration-300 hover:-translate-y-1"
                >
                  <img
                    src={client.client}
                    alt={`Client ${idx % Client_data.length + 1}`}
                    className="w-14 h-14 object-contain mb-3 rounded-2xl bg-green-50 p-2 shadow-inner"
                  />
                  <div className="flex flex-col gap-3">
                    <div className="rounded-2xl bg-slate-50 p-3 flex items-center gap-2">
                      <span className="text-lg">{client.CO2}</span>
                      <span className="text-lg font-black text-green-800">{client.CO2_data}</span>
                    </div>
                    <span className="text-xs text-gray-500">CO₂ Saved (kg)</span>
                    <div className="rounded-2xl bg-emerald-50 p-3 flex items-center gap-2">
                      <span className="text-lg">{client.trees}</span>
                      <span className="text-lg font-black text-green-800">{client.tree_data}</span>
                    </div>
                    <span className="text-xs text-gray-500">Trees Planted</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <style>
            {`
              @keyframes scroll-x {
                0% { transform: translateX(0); }
                100% { transform: translateX(-50%); }
              }
              @media (max-width: 768px) {
                .animate-scroll-x {
                  animation-duration: 20s !important;
                }
              }
            `}
          </style>
        </div>
      </section>
      
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
          <div className="bg-white p-6 md:p-8 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto relative">
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-2 text-2xl text-gray-600 hover:text-gray-800"
            >
              &times;
            </button>
            {getModalContent(activeService)}
            <div className="flex justify-center">
              <button
                onClick={handleOpenForm}
                className="btn-glow-slide relative overflow-hidden mt-4 bg-green-800 text-white py-2 px-4 rounded"
              >
                Enquire Now
              </button>
            </div>
          </div>
        </div>
      )}

      
      {showForm && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
          <div className="bg-white p-6 md:p-8 rounded-lg shadow-lg w-full max-w-xl max-h-[90vh] overflow-y-auto relative">
            <button
              onClick={handleCloseForm}
              className="absolute top-2 right-2 text-2xl text-gray-600 hover:text-gray-800"
            >
              &times;
            </button>
            <h3 className="text-2xl font-bold mb-4 text-green-800 text-center">Enquiry Form</h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-gray-700">Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded"
                />
                {errors.name && <p className="text-red-600">{errors.name}</p>}
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded"
                />
                {errors.email && <p className="text-red-600">{errors.email}</p>}
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded"
                />
                {errors.phone && <p className="text-red-600">{errors.phone}</p>}
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">Description</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded"
                  rows="4"
                ></textarea>
                {errors.description && <p className="text-red-600">{errors.description}</p>}
              </div>
              <div className="flex justify-center">
                <button type="submit" className="btn-glow-slide relative overflow-hidden bg-green-800 text-white py-2 px-4 rounded">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

     
      {showSuccess && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-md mx-4 text-center">
            <div className="text-green-800 text-4xl mb-4">✔</div>
            <p className="text-lg text-gray-700 mb-4">Thank you for your interest. We will get back to you shortly!</p>
          </div>
        </div>
      )}
      
      <section className="relative py-16 bg-gradient-to-b from-white via-green-50 to-white overflow-hidden">
  {/* Animated Background Glow */}
  <div className="absolute inset-0 -z-10 flex justify-center items-center opacity-40 blur-3xl">
    <div className="w-[600px] h-[600px] bg-green-300 rounded-full animate-pulse"></div>
  </div>

  <h2 className="text-4xl md:text-5xl font-extrabold mb-12 text-center text-green-800 drop-shadow-lg animate-fadeIn">
    🌍 Our Presence
  </h2>

  <div className="container mx-auto relative px-4">
    {/* Subtle background image overlay */}
    {/* <div
      className="absolute inset-0 w-full h-full z-0 rounded-lg overflow-hidden"
      style={{
        backgroundImage: `url(${bgIMG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        opacity: 0.1,
      }}
    ></div> */}

    <div className="relative flex flex-col md:flex-row justify-between items-center gap-10 z-10">
      {/* Left Image */}
      <div
        className="hidden md:flex relative w-3/4 md:w-1/2 h-72 md:h-auto items-center justify-center rounded-3xl overflow-hidden shadow-2xl transform transition-all duration-700 hover:scale-105"
      >
        <img
          src={footerimg}
          alt="Logo"
          className="relative z-10 w-full h-full object-contain animate-float-slow"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-green-200/30 to-transparent"></div>
      </div>

      {/* Right Map Image */}
      <div
        className="relative w-3/4 md:w-1/2 h-72 md:h-auto flex items-center justify-center rounded-3xl overflow-hidden shadow-2xl transform transition-all duration-700 hover:scale-105"
      >
        <img
          src={mapImage}
          alt="Map"
          className="relative z-10 w-full h-full object-contain animate-float"
        />
        <div className="absolute inset-0 bg-gradient-to-tl from-green-100/30 to-transparent"></div>
      </div>
    </div>
  </div>

  {/* Floating Animation Keyframes */}
  {/* <style>{`
    @keyframes float {
      0%, 100% { transform: translateY(0px); }
      50% { transform: translateY(-10px); }
    }
    @keyframes float-slow {
      0%, 100% { transform: translateY(0px); }
      50% { transform: translateY(-15px); }
    }
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .animate-float {
      animation: float 4s ease-in-out infinite;
    }
    .animate-float-slow {
      animation: float-slow 6s ease-in-out infinite;
    }
    .animate-fadeIn {
      animation: fadeIn 1.2s ease-out forwards;
    }
  `}</style> */}
</section>

      <ScrollToTopButton />
    </div>
    </>

  );
};

export default Services;
